<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="InfoGrid">
	<label>Sub Name:</label>
	<label class="InfoText">{{ PersonName }}</label>

	<label>Person Type:</label>
	<label class="InfoText">{{ PersonTypeDesc }}</label>

	<label>Start Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate" (ngModelChange)="onStartDateChange($event)"></p-calendar>

	<label>End Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate" (ngModelChange)="onEndDateChange($event)"></p-calendar>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSubstitution"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSubstitution"
		dataKey="SubstitutionID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!-- <th></th> -->

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartDate-->
				<th>
					<!-- <p-columnFilter type="text" field="StartDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDate-->
				<th>
					<!-- <p-columnFilter type="text" field="EndDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--CreatedBy-->
				<th>
					<p-columnFilter type="text" field="CreatedBy" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Classes-->
				<th>
					<p-columnFilter type="text" field="Classes" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!-- <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th> -->

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PersonName">Subbing For<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
				<th pSortableColumn="CreatedBy">Created By<p-sortIcon field="CreatedBy"></p-sortIcon></th>
				<th pSortableColumn="Classes">Classes<p-sortIcon field="Classes"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Substitution>
			<tr [pSelectableRow]="Substitution" (dblclick)="onRowDblClick(Substitution)">
				<!-- <td>
                    <p-tableCheckbox [value]="Substitution"></p-tableCheckbox>
                </td> -->

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Substitution[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onEdit()">Edit</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
